import * as React from "react";
import type { SVGProps } from "react";
const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.87 5.115c.167.16.174.427.016.596l-8.579 9.157a.416.416 0 0 1-.599.008l-4.586-4.629a.424.424 0 0 1 0-.596.415.415 0 0 1 .591 0l4.282 4.323 8.284-8.842a.415.415 0 0 1 .59-.017"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCheck;
